import React, { useEffect } from 'react';
import { LivePracticeFeatures } from './components/onboardingView/LivePracticeFeatures';
import { OnboardingView } from './components/onboardingView/OnboardingView';
import { OnboardingViewModal } from './components/onboardingView/OnboardingViewModal';
import { CreateOnboardingView } from './components/onboardingView/CreateOnboardingView';
import { useAppDispatch } from './components/onboardingView/store/hooks';
import { setModalCreateOnboarding, fetchOnboardings } from './components/onboardingView/store/onboardingSlice';
import './OnboardingViewWrapper.css';

// const BASE_URL = 'http://localhost:5002';

const OnboardingViewWrapper = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchOnboardings());
  }, [dispatch]);

  return (
    <>
      {/* Modals */}
      <CreateOnboardingView />
      <OnboardingViewModal />

      {/* Header */}
      <div className="onboarding-wrapper-header">
        <h1 className="onboarding-wrapper-title">Onboardings</h1>
        <div>
          <button
            onClick={() => dispatch(setModalCreateOnboarding())}
            className="onboarding-wrapper-create-button"
          >
            Create New Onboarding
          </button>
          <button 
            onClick={() => dispatch(fetchOnboardings())}
            className="onboarding-wrapper-refresh-button"
          >
            Refresh
          </button>
        </div>
      </div>

      {/* Onboarding Table */}
      <OnboardingView />

      <LivePracticeFeatures />
      
    </>
  );
};

export { OnboardingViewWrapper };